<template>
   <v-select v-model="value" :label="label" @input="seleccionado();" :options="options" :placeholder="placeholder" @search="onSearch" @click="onSearch" :multiple="multiple" :searchable="true" :filterable="filterable" >
        <template v-slot:no-options="{ search }">
            <template >
            No se encontraron resultados {{search}}
            </template>
        </template>
    </v-select>
</template>

<script>
import axios from 'axios'
export default {
    name:'VueSelect',
    props:['source','method','label','placeholder','multiple','filterable'],
     data() {
        return {
            options:[],
            value:null
        }
    },

      mounted(){
        //   if(this.valor!=''){
             
        //   }
          this.filterable=false;
          this.multiple=false;
      },
      methods:{
         onSearch(search, loading) {
             console.log("cho");
                // if(search.length) {
                    loading(true);
                    if(this.method=='get' || this.method=='GET'){
                        axios.get(this.source+search).then(respuesta => {
                            this.options=respuesta.data.data
                            loading(false);
                        }).catch(function (error) {
                             console.log(error);
                        });
                    }else if(this.method=='post' || this.method=='POST'){
                        axios.post(this.source+search).then(respuesta => {
                            this.options=respuesta.data.data
                            loading(false);
                        }).catch(function (error) {
                             console.log(error);
                        });
                    }
                    
                // }
        },

        seleccionado() {
            this.$emit('selected',this.value);
        },
        
    }
    
}
</script>
